import { number, string } from "@rocicorp/zero";

/**
 * The columns the synced tables share. A `.from()` here carries the database's snake_case
 * spelling once for every table that spreads the group in; the camelCase key is what the
 * queries, mutators, relationships and the apps read.
 */
export const coreFields = {
	id: string(),
	createdBy: string().from("created_by"),
	createdAt: number().from("created_at"),
	updatedBy: string().from("updated_by"),
	updatedAt: number().from("updated_at").optional(),
};

export const addressFields = {
	streetName: string().from("street_name"),
	houseNumber: string().from("house_number"),
	zipCode: string().from("zip_code"),
	city: string(),
};
